import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-gray-400">Loading...</p>
      </div>
    </div>
  );
}

export function StudentProtectedRoute() {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingSpinner />;

  if (!user) {
    return <Navigate to="/student/login" state={{ from: location.pathname }} replace />;
  }

  // An authenticated Admin hitting a student-only route is blocked, not
  // logged out — sent to their own dashboard rather than exposing the
  // student portal.
  if (isAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
}

export function AdminProtectedRoute() {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingSpinner />;

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  // An authenticated Student hitting an admin-only route is blocked, not
  // logged out — sent to their own dashboard rather than exposing admin data.
  if (!isAdmin) {
    return <Navigate to="/student/dashboard" replace />;
  }

  return <Outlet />;
}